import { createSlice } from '@reduxjs/toolkit';
export default createSlice({
    name: 'product',
    initialState: {
        current: null,
        userShoppingInfo: null,
    },
    reducers: {
        updateCurrent: (state, action) => {
            state.current = action.payload;
        },
        updateUserShoppingInfo: (state, action) => {
            state.userShoppingInfo = action.payload;
        },
    },
});
